module.exports = __webpack_public_path__ + "static/media/wordpress.db4298ab.png";